import { Pipe, PipeTransform } from '@angular/core';
import { getFileTypeIconByName } from '@appshared';

/**
 * Wrap the show file icon function `getFileTypeIconByName()`, otherwise Angular will directly call to this function in its cycles multiple times
 * Imaginng a list of 5-10 documents without this pipe...
 *
 * Example using:  <mat-icon [svgIcon]="attachment.name | getFileIcon"></mat-icon>
 *
 */
@Pipe({
  name: 'getFileIcon',
})
export class GetFileIconPipe implements PipeTransform {
  transform(fileName: string): string {
    return getFileTypeIconByName(fileName);
  }
}
